module.exports = __webpack_public_path__ + "img/Mask Group 6@2x.png";